<template>
  <div>
    <div class="mb-3">
      <div class="col-md-12">
        <label class="form-col-label control-label required">{{
          $t('jobTitle.jobTitleKh')
        }}</label>
        <input
          v-model.trim="model.job_title_kh"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('job_title_kh') }"
          ref="job_title_kh"
        />
        <div class="invalid-feedback" v-if="errors.has('job_title_kh')">
          {{ errors.first('job_title_kh') }}
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="col-md-12">
        <label class="form-col-label control-label required">{{
          $t('jobTitle.jobTitleEn')
        }}</label>
        <input
          v-model.trim="model.job_title_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('job_title_en') }"
        />
        <div class="invalid-feedback" v-if="errors.has('job_title_en')">
          {{ errors.first('job_title_en') }}
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="ts-flex ts-justify-end ts-space-x-2 ts-sh">
        <ts-button @click.prevent="() => $emit('cancel')" class="btn-gray">
          {{ $t('cancel') }}</ts-button
        >
        <ts-button
          v-if="!isUpdate"
          color="primary"
          outline
          :waiting="waiting_new"
          :disabled="waiting"
          @click.prevent="onSaveAddNew"
        >
          {{ $t('saveAddNew') }}</ts-button
        >
        <ts-button
          color="primary"
          v-if="!isUpdate"
          :waiting="waiting"
          :disabled="waiting_new"
          @click.prevent="onSave"
        >
          {{ $t('save') }}</ts-button
        >
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
        >
          {{ $t('update') }}</ts-button
        >
      </div>
    </div>
    <Spin size="large" fix v-if="loading"> </Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { isEmpty } from 'lodash'

// iview
//import 'view-design/dist/styles/iview.css'
import Vue from 'vue'
import ViewUI from 'view-design'
import locale from 'view-design/dist/locale/en-US'
Vue.use(ViewUI, { locale })
Vue.use(ViewUI)

export default {
  name: 'job-titleForm',
  data () {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_new: false,
      model: {
        job_title_kh: null,
        job_title_en: null
      }
    }
  },
  computed: {
    ...mapState('humanResource/jobTitle', ['edit_data']),
    isUpdate () {
      return !isEmpty(this.edit_data)
    }
  },
  methods: {
    async onSaveAddNew () {
      this.errors = new Errors()
      this.waiting_new = true
      this.$store
        .dispatch('humanResource/jobTitle/store', this.model)
        .then(response => {
          this.notice({
            type: response.message_id == 0 ? 'success' : 'warning',
            text: response.message
          })
          this.$emit('fetchData')
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    async onSave () {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('humanResource/jobTitle/store', this.model)
        .then(response => {
          this.notice({
            type: response.message_id == 0 ? 'success' : 'warning',
            text: response.message
          })
          this.$emit('cancel')
          this.$emit('fetchData')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate () {
      this.waiting = true
      this.$store
        .dispatch('humanResource/jobTitle/update', {
          id: this.edit_data.job_title_id,
          data: this.model
        })
        .then(response => {
          this.notice({
            type: response.message_id == 0 ? 'success' : 'warning',
            text: response.message
          })
          this.$emit('cancel')
          this.$emit('fetchData')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData () {
      this.$nextTick(function () {
        this.$refs.job_title_kh.focus()
      })
      if (!isEmpty(this.edit_data)) {
        this.model.job_title_kh = this.edit_data.job_title_kh
        this.model.job_title_en = this.edit_data.job_title_en
      }
    },
    clearInput () {
      this.errors = new Errors()
      this.model.job_title_kh = null
      this.model.job_title_en = null
    },
    notice (not) {
      this.$Notice[not.type]({
        title: 'JOB TITLE',
        desc: not.text
      })
    }
  }
}
</script>
